var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { RideTrackerMapService } from '../ride-tracker-map/ride-tracker-map.service';
var DistTimeDetailsComponent = /** @class */ (function () {
    function DistTimeDetailsComponent(rideTrackerMapService) {
        this.rideTrackerMapService = rideTrackerMapService;
    }
    DistTimeDetailsComponent.prototype.ngOnInit = function () {
    };
    DistTimeDetailsComponent.prototype.ngOnChanges = function (changes) {
        // Handle poolInfo changes - fetch trip match data for HOPR orders
        if (changes && changes.poolInfo && changes.poolInfo.currentValue && changes.poolInfo.currentValue.type === 'MPMD_CORPORATE_POOL' && changes.poolInfo.currentValue.tripMatchId) {
            this.fetchTripMatchData();
            // If we just triggered a fetch for HOPR order, skip distTimeDetails handling below to avoid race condition
            if (changes.distTimeDetails && changes.distTimeDetails.currentValue) {
                return;
            }
        }
        // Handle distTimeDetails changes - construct appropriate card
        if (changes.distTimeDetails && changes.distTimeDetails.currentValue) {
            if (!changes.distTimeDetails.currentValue.dataFetched) {
                this.emptyCard();
            }
            else {
                // Check if this is a HOPR order with trip match data - use trip match card, otherwise use regular card
                if (this.poolInfo && this.poolInfo.type === 'MPMD_CORPORATE_POOL' && this.tripMatchData) {
                    this.constructTripMatchCard();
                }
                else {
                    this.constructCard();
                }
            }
        }
        else if (!changes.distTimeDetails) {
            // If only poolInfo changed and we don't have distTimeDetails, do nothing (wait for distTimeDetails)
            // This prevents showing empty card when poolInfo changes but distTimeDetails hasn't loaded yet
            return;
        }
    };
    // Fetch the trip match data for HOPR orders
    DistTimeDetailsComponent.prototype.fetchTripMatchData = function () {
        var _this = this;
        if (this.poolInfo.tripMatchId) {
            this.rideTrackerMapService.getPoolTripMatchById(this.poolInfo.tripMatchId).subscribe(function (result) {
                if (result && result['data']) {
                    _this.tripMatchData = result['data'];
                }
                else if (result && result['id']) {
                    // Direct trip match object response
                    _this.tripMatchData = result;
                }
                _this.constructTripMatchCard();
            }, function (error) {
                // Even if API fails, construct the regular card
                _this.tripMatchData = null;
                _this.constructCard();
            });
        }
        else {
            this.constructCard();
        }
    };
    DistTimeDetailsComponent.prototype.emptyCard = function () {
        this.info = {
            tableHeader: 'Distance & Time',
            dataFetched: false,
            data: [],
            emptyMessage: 'No data found'
        };
    };
    DistTimeDetailsComponent.prototype.constructCard = function () {
        // Original method for regular orders
        var data = {};
        var headers = {};
        if (this.distTimeDetails.acceptToCancel) {
            headers = { acceptToCancel: 'Accept to cancel' };
            data = { acceptToCancel: { data: this.distTimeDetails.acceptToCancel ? this.distTimeDetails.acceptToCancel + ' kms' : '' } };
        }
        data = __assign({}, data, { acceptToPickup: { data: this.distTimeDetails.acceptToPickup ? this.distTimeDetails.acceptToPickup + ' kms' : '' }, estimatedDistance: { data: this.distTimeDetails.estimatedDistance ? this.distTimeDetails.estimatedDistance + ' kms' : '' }, finalEstimatedDistance: { data: this.distTimeDetails.finalEstimatedDistance ? this.distTimeDetails.finalEstimatedDistance + ' kms' : this.distTimeDetails.finalDistance ? this.distTimeDetails.finalDistance + ' kms' : '' }, hfDistance: { data: this.distTimeDetails.hfDistance ? this.distTimeDetails.hfDistance + ' kms' : '' }, estimatedRideTime: { data: this.distTimeDetails.estimatedRideTime ? this.distTimeDetails.estimatedRideTime + ' mins' : '' }, finalRideTime: { data: this.distTimeDetails.finalRideTime ? this.distTimeDetails.finalRideTime + ' mins' : '' }, pickupCluster: { information: this.distTimeDetails.pickupCluster && this.distTimeDetails.pickupCluster.radius ? this.distTimeDetails.pickupCluster.radius + ' kms' : null,
                data: this.distTimeDetails.pickupCluster && this.distTimeDetails.pickupCluster.name ? this.distTimeDetails.pickupCluster.name : '' }, dropCluster: { information: this.distTimeDetails.dropCluster && this.distTimeDetails.dropCluster.radius ? this.distTimeDetails.dropCluster.radius + ' kms' : null,
                data: this.distTimeDetails.dropCluster && this.distTimeDetails.dropCluster.name ? this.distTimeDetails.dropCluster.name : '' }, odrdDistance: { data: this.distTimeDetails.odrdDistance ? this.distTimeDetails.odrdDistance + ' kms' : '' }, distanceSuggested: { data: this.distTimeDetails.distanceSuggested ? this.distTimeDetails.distanceSuggested : '' } });
        var allHeaders = __assign({}, headers, { acceptToPickup: 'Accept to pickup', estimatedDistance: 'Initial Estimated distance', finalEstimatedDistance: 'Final Estimated distance', hfDistance: 'Hf distance', estimatedRideTime: 'Initial Estimated ride time', finalRideTime: 'Actual ride time', odrdDistance: 'ODRD(Actual) Distance', distanceSuggested: 'Distance Suggested', pickupCluster: 'Pickup cluster', dropCluster: 'Drop cluster' });
        this.info = {
            tableHeader: 'Distance & Time',
            expandTable: false,
            headers: allHeaders,
            headerClass: 'color-card-header',
            dataFetched: true,
            data: [data]
        };
    };
    // Construct the card for HOPR orders
    DistTimeDetailsComponent.prototype.constructTripMatchCard = function () {
        // Method for HOPR orders - shows only pool-specific columns
        if (!this.tripMatchData || !this.tripMatchData.distancesInMeters || !this.tripMatchData.distancesInMeters.guest) {
            // Fallback to regular card if no trip match data
            this.constructCard();
            return;
        }
        var guestDistances = this.tripMatchData.distancesInMeters.guest;
        var data = {
            guestFirstMile: { data: guestDistances.firstMile ? (guestDistances.firstMile / 1000).toFixed(2) + ' kms' : '0.00 kms' },
            guestLastMile: { data: guestDistances.lastMile ? (guestDistances.lastMile / 1000).toFixed(2) + ' kms' : '0.00 kms' },
            overlapDistance: { data: guestDistances.startToEnd ? (guestDistances.startToEnd / 1000).toFixed(2) + ' kms' : '0.00 kms' }
        };
        // Add time column if available
        if (this.tripMatchData.pricing && this.tripMatchData.pricing.timeInMins) {
            data = __assign({}, data, { startToEndTimeInMins: { data: this.tripMatchData.pricing.timeInMins + ' mins' } });
        }
        var allHeaders = {
            guestFirstMile: 'Guest Start to HopIn (FM)',
            guestLastMile: 'HopOut to Guest Drop (LM)',
            overlapDistance: 'Overlap Distance'
        };
        if (this.tripMatchData.pricing && this.tripMatchData.pricing.timeInMins) {
            allHeaders = __assign({}, allHeaders, { startToEndTimeInMins: 'Start to End Time' });
        }
        this.info = {
            tableHeader: 'Distance & Time',
            expandTable: false,
            headers: allHeaders,
            headerClass: 'color-card-header',
            dataFetched: true,
            data: [data]
        };
    };
    return DistTimeDetailsComponent;
}());
export { DistTimeDetailsComponent };
